import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function InfoPage({ title, kicker, body }: { title: string; kicker: string; body: string[] }) {
  return (
    <Layout>
      <section>
        <div className="shell pt-24 pb-16">
          <Breadcrumb items={[{ label: title }]} />
          <h1 className="mt-8 font-display text-5xl md:text-6xl text-black">{title}</h1>
        </div>
        <div className="shell pb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-8 md:col-start-3 space-y-6 text-graphite leading-[1.9] text-[15px]">
            {body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>
      </section>
    </Layout>
  );
}

export function Shipping() {
  return (
    <InfoPage
      title="Shipping & Returns"
      kicker="Customer Care"
      body={[
        "All Aurelin orders ship complimentary via insured, signature-required courier worldwide. Orders are made-to-order and typically dispatched from our Antwerp atelier within 5–7 business days.",
        "Returns are accepted within 30 days of delivery for a full refund, provided pieces are unworn and returned in their original Aurelin packaging.",
        "Engraved, resized or fully bespoke orders are considered final sale. For any questions, our client care team is available Monday through Friday.",
      ]}
    />
  );
}

export function Privacy() {
  return (
    <InfoPage
      title="Privacy"
      kicker="Legal"
      body={[
        "Aurelin collects only the personal information necessary to process your order and share considered updates about new collections. We do not sell your data to third parties.",
        "You may request access, correction or deletion of your personal data at any time by writing to our client care team.",
      ]}
    />
  );
}

export function Terms() {
  return (
    <InfoPage
      title="Terms"
      kicker="Legal"
      body={[
        "By using aurelin.com you agree to purchase for personal, non-commercial use. All imagery and copy is the property of Aurelin Maison.",
        "Prices are listed in USD and may be subject to duties and taxes on delivery outside the European Union.",
      ]}
    />
  );
}